import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';
import { isDevMode } from '@angular/core';

// TODO(yuna): spotlight für dev mode hinzufügen
if (!isDevMode()) {
Sentry.init({
  dsn: "https://b1dbf77438fc6b17bedc9b187b098cb5@sentry.appkreativ.dev/5",
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      autoInject: false,
    }),
    Sentry.replayIntegration(),
    Sentry.httpClientIntegration(),
  ],
  environment: environment.sentryEnvironment,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});
}


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
